import { useEffect } from 'react';
import get from 'lodash/get';
import isFunction from 'lodash/isFunction';
import isArray from 'lodash/isArray';
import forEach from 'lodash/forEach';
import { publicPath } from '../../core/helpers'
import { useModal } from '../../context/modal-context'
import RequestForm from '../form/request-form';

const translations = require('../../assets/json/translations.json');

function App() {
  const { setModal, setModalOptions } = useModal();

  const allowedForms = ['offer', 'testdrive'];

  const sanitizeFormType = (type) => {
    return (allowedForms.indexOf(type) === -1) ? allowedForms[0] : type;
  }

  const config = get(window, 'MLB_FORM_CONFIG', {});
  const lang = get(config, 'lang', 'pl');
  const type = sanitizeFormType(get(config, 'type'));
  const init = get(config, 'init', true);
  const langTranslations = get(translations, lang, false);


  useEffect(() => {
    if (init) {
      setModalOptions({size: 'default'});
      setModal(<RequestForm translations={langTranslations} type={type}/>);
    }

    document.addEventListener('click', function (event) {
      let target = false;
      if (isArray(event.path)) {
        forEach(event.path, (parent) => {
          if (isFunction(parent.matches) && parent.matches('[data-mlb-form]')) {
            target = parent;
            return false;
          }
        })
      } else {
        if (event.target.matches('[data-mlb-form]')) {
          target = get(event, 'target');
        } else if (isFunction(get(event, 'target.parentNode.matches')) && event.target.parentNode.matches('[data-mlb-form]')) {
          target = get(event, 'target.parentNode');
        } else if (isFunction(get(event, 'target.parentNode.parentNode.matches')) && event.target.parentNode.parentNode.matches('[data-mlb-form]')) {
          target = get(event, 'target.parentNode.parentNode');
        } else if (isFunction(get(event, 'target.parentNode.parentNode.parentNode.matches')) && event.target.parentNode.parentNode.parentNode.matches('[data-mlb-form]')) {
          target = get(event, 'target.parentNode.parentNode.parentNode');
        }
      }
      if (target) {
        const customType = sanitizeFormType(get(target, 'dataset.mlbForm'));
        const customLang = get(target, 'dataset.lang', lang);
        const customTranslations = get(translations, customLang, langTranslations);
        setModalOptions({size: 'default'});
        setModal(<RequestForm translations={customTranslations} type={customType}/>);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="mlb-form-app">
      { process.env.NODE_ENV === 'production' &&
        <link rel="stylesheet" type="text/css" href={publicPath('static/css/main.css')} />}
    </div>
  );
}

export default App;
